import { useState } from "react";
import { Form, Button, Card, Container, Modal } from "react-bootstrap";
import API from "../services/api";
import { ShieldCheck } from "react-bootstrap-icons";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPass, setShowPass] = useState(false);

  // 🔥 SEND OTP
  const handleSendOtp = async () => {
    if (!email) return alert("Enter email");

    setLoading(true);

    const fd = new FormData();
    fd.append("email", email);

    const res = await API.post("/auth/forgot-password-send-otp.php", fd);

    if (res.data.status === "success") {
      setShowModal(true);
    } else {
      alert(res.data.msg);
    }

    setLoading(false);
  };

  // 🔥 RESET PASSWORD
  const handleReset = async () => {
    if (newPassword !== confirmPassword) {
      return alert("Passwords do not match");
    }

    if (newPassword.length < 6) {
      return alert("Password must be at least 6 characters");
    }

    const fd = new FormData();
    fd.append("email", email);
    fd.append("otp", otp);
    fd.append("password", newPassword);

    const res = await API.post("/auth/reset-password.php", fd);

    if (res.data.status === "success") {
      window.location.href = "/login";
    } else {
      alert(res.data.msg);
    }
  };

  return (
    <Container 
      fluid
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9fd 100%)" }}
    >
      <Card
        className="shadow-lg border-0"
        style={{ maxWidth: "420px", width: "100%", borderRadius: "1.25rem" }}
      >
        <Card.Body className="p-5 text-center">

          {/* HEADER */}
          <div className="mb-4">
            <ShieldCheck size={64} className="text-primary mb-3" />
            <h3 className="fw-bold mb-1">Reset Password</h3>
            <p className="text-muted">Enter your registered email</p>
          </div>

          {/* FORM */}
          <Form className="text-start">
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="john@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-pill px-4 py-2"
              />
            </Form.Group>

            <Button
              variant="primary"
              size="lg"
              className="w-100 rounded-pill fw-bold py-3"
              onClick={handleSendOtp}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Sending OTP...
                </>
              ) : (
                "Send OTP"
              )}
            </Button>
          </Form>

        </Card.Body>
      </Card>

      {/* 🔥 MODAL */}
      <Modal show={showModal} centered backdrop="static">
        <Modal.Body className="p-4">

          <h5 className="fw-bold mb-3 text-center">Verify OTP</h5>

          <Form.Control
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="mb-3 rounded-pill px-4 py-2"
          />

          {/* PASSWORD FIELD */}
          <div className="position-relative mb-2">
            <Form.Control
              type={showPass ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="rounded-pill px-4 py-2 pe-5"
            />

            <span
              onClick={() => setShowPass(!showPass)}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {showPass ? <EyeSlash /> : <Eye />}
            </span>
          </div>

          <Form.Control
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="mb-3 rounded-pill px-4 py-2"
          />

          <Button className="w-100 rounded-pill py-2" onClick={handleReset}>
            Reset Password
          </Button>

        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ForgotPassword;